var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.355,
    height: 55.113,
    viewBox: "0 0 54.355 55.113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20.311 -18.81)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.311 18.81)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.292)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.598,
    cy: 14.598,
    r: 14.598,
    fill: "#ef7816"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.586,
    cy: 11.586,
    r: 11.586,
    transform: "translate(3.012 3.012)",
    fill: "#ffc91d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.6,39.584a11.584,11.584,0,0,1-16.187,16.187A11.585,11.585,0,1,0,145.6,39.584Z",
    transform: "translate(-124.172 -34.341)",
    fill: "#ffa91a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.032,51.547h-.665V46.708h.665a2.422,2.422,0,0,1,2.419,2.419.5.5,0,1,0,1.009,0,3.433,3.433,0,0,0-3.429-3.429h-.665v-.665a.5.5,0,1,0-1.009,0V45.7h-.665a3.429,3.429,0,0,0,0,6.858h.665v6.008h-.665a2.422,2.422,0,0,1-2.419-2.419.5.5,0,0,0-1.009,0,3.433,3.433,0,0,0,3.429,3.429h.665v.665a.5.5,0,1,0,1.009,0v-.665h.665a3.433,3.433,0,0,0,3.429-3.429v-1.17A3.433,3.433,0,0,0,154.032,51.547Zm-2.339,0a2.419,2.419,0,0,1,0-4.839h.665v4.839Zm4.758,4.6a2.422,2.422,0,0,1-2.419,2.419h-.665V52.556h.665a2.422,2.422,0,0,1,2.419,2.419Z",
    transform: "translate(-138.264 -38.038)",
    fill: "#995222"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.081)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.598,
    cy: 14.598,
    r: 14.598,
    transform: "translate(0)",
    fill: "#0f7989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.191,18.81a14.6,14.6,0,1,0,14.6,14.6,14.6,14.6,0,0,0-14.6-14.6Zm0,28.078A13.481,13.481,0,1,1,52.672,33.408,13.481,13.481,0,0,1,39.191,46.888Z",
    transform: "translate(-24.593 -18.81)",
    fill: "#1c8697"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.58,
    cy: 11.58,
    r: 11.58,
    transform: "translate(3.018 3.018)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.562,39.6A11.578,11.578,0,0,1,45.383,55.779,11.579,11.579,0,1,0,61.562,39.6Z",
    transform: "translate(-40.136 -34.353)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.66 3.66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.277,53H79.506a1.449,1.449,0,0,0-.852-.856V46.186a.5.5,0,1,0-1.009,0v5.957A1.447,1.447,0,1,0,79.5,54.007h3.775a.5.5,0,1,0,0-1.009Z",
    transform: "translate(-67.21 -42.559)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.942,34.923a.5.5,0,0,1-.5-.5v-.6a.5.5,0,1,1,1.009,0v.6A.5.5,0,0,1,80.942,34.923Z",
    transform: "translate(-80.437 -33.312)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.942,115.223a.5.5,0,0,1-.5-.5v-.6a.5.5,0,1,1,1.009,0v.6A.5.5,0,0,1,80.942,115.223Z",
    transform: "translate(-80.437 -93.347)",
    fill: "#414042"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.2,75.663h-.6a.5.5,0,0,1,0-1.009h.6a.5.5,0,1,1,0,1.009Z",
    transform: "translate(-39.095 -74.654)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.5,75.663h-.6a.5.5,0,1,1,0-1.009h.6a.5.5,0,0,1,0,1.009Z",
    transform: "translate(-99.13 -74.654)",
    fill: "#414042"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 28.173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.408,131.459l-.068-.068a3.226,3.226,0,0,0-4.564,0l-8.835,8.837a2.987,2.987,0,0,1-2.117.875H84.556a3.764,3.764,0,0,0-.019-7.528H76.4a7.5,7.5,0,0,0-5.378,2.274l-5.1,5.254H64v12.534H84.931A9,9,0,0,0,91.292,151l15.115-15.113A3.132,3.132,0,0,0,106.408,131.459Z",
    transform: "translate(-52.97 -130.445)",
    fill: "#fcc4ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.585,135.243a3.122,3.122,0,0,1-.909,2.407L90.561,152.763A9,9,0,0,1,84.2,155.4H63.994v1.826H84.93a9,9,0,0,0,6.361-2.634l15.115-15.113A3.13,3.13,0,0,0,106.585,135.243Z",
    transform: "translate(-52.97 -134.032)",
    fill: "#f2ad97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.508,153.829H118.8v-1.1h5.981a3.763,3.763,0,0,0,3.451-5.266,3.761,3.761,0,0,1-2.721,6.361Z",
    transform: "translate(-93.942 -143.172)",
    fill: "#f2ad97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.858,153.1h.763a2.019,2.019,0,0,0,2.019-2.019v-.713a2.019,2.019,0,0,0-2.019-2.019h-.763a.5.5,0,0,0-.5.5v3.741A.5.5,0,0,0,138.858,153.1Z",
    transform: "translate(-108.563 -143.828)",
    fill: "#ffd2c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.073,177.849h-8.5a1.262,1.262,0,0,1-1.262-1.262V159.08a1.262,1.262,0,0,1,1.262-1.262h8.5a1.262,1.262,0,0,1,1.262,1.262v17.507A1.262,1.262,0,0,1,30.073,177.849Z",
    transform: "translate(-20.311 -150.91)",
    fill: "#0f7989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.816,174.783a.5.5,0,0,1-.5-.5v-9.842a.5.5,0,1,1,1.009,0v9.842A.5.5,0,0,1,24.816,174.783Zm0-11.861a.5.5,0,0,1-.5-.5v-.094a.5.5,0,1,1,1.009,0v.094A.5.5,0,0,1,24.816,162.921Z",
    transform: "translate(-23.302 -153.9)",
    fill: "#5e9cf7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.335,159.081a1.262,1.262,0,0,0-1.262-1.262H26.288v13.722a1.262,1.262,0,0,1-1.262,1.262H20.311v3.786a1.262,1.262,0,0,0,1.262,1.262h8.5a1.262,1.262,0,0,0,1.262-1.262Z",
    transform: "translate(-20.311 -150.911)",
    fill: "#1c8697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.335,159.081a1.262,1.262,0,0,0-1.262-1.262H28.812v16.246a1.262,1.262,0,0,1-1.262,1.262H20.311v1.262a1.262,1.262,0,0,0,1.262,1.262h8.5a1.262,1.262,0,0,0,1.262-1.262Z",
    transform: "translate(-20.311 -150.911)",
    fill: "#0f7989"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyTime);
export default __webpack_public_path__ + "static/media/money-time.6fdd5788bc7bb79b7572fa2f75e8ef66.svg";
export { ForwardRef as ReactComponent };